import React from"react";
import { SparklesIcon, XMarkIcon, ArrowRightIcon } from"@heroicons/react/24/outline";

/**
 * Payment Reminder Popup for SkillGenie ChatBot
 * Shows after 3 minutes of login, 2 times per session
 * Highlights TSG AI for 6 months and 1 year payment
 */
const PaymentReminderPopup = ({ onClose, onUpgrade }) => {
  return (
    <div
      style={{
        position:"fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor:"rgba(244, 249, 253, 0.95)", // bg-bgMain with opacity
        display:"flex",
        alignItems:"center",
        justifyContent:"center",
        zIndex: 10000,
        backdropFilter:"blur(8px)"
      }}
    >
      <div
        style={{
          background:"#E3F2FD", // Light Blue
          borderRadius:"32px",
          padding:"32px",
          maxWidth:"480px",
          width:"90%",
          boxShadow:"0 25px 50px rgba(31, 138, 203, 0.15)",
          position:"relative",
          animation:"slideIn 0.4s cubic-bezier(0.16, 1, 0.3, 1)",
          border:"1px solid var(--accent-gray)",
        }}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          style={{
            position:"absolute",
            top:"16px",
            right:"16px",
            background:"var(--bg-main)",
            border:"1px solid var(--accent-gray)",
            color:"var(--text-muted)",
            cursor:"pointer",
            padding:"6px",
            borderRadius:"10px",
            width:"32px",
            height:"32px",
            display:"flex",
            alignItems:"center",
            justifyContent:"center",
            transition:"all 0.3s ease",
            zIndex: 10,
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor ="var(--primary-blue)";
            e.currentTarget.style.color ="#ffffff";
            e.currentTarget.style.transform ="rotate(90deg) scale(1.1)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor ="var(--bg-main)";
            e.currentTarget.style.color ="var(--text-muted)";
            e.currentTarget.style.transform ="rotate(0deg) scale(1)";
          }}
        >
          <XMarkIcon style={{ width:"20px", height:"20px" }} />
        </button>

        {/* Header */}
        <div style={{ textAlign:"center", marginBottom:"24px" }}>
          <div style={{ display:"flex", justifyContent:"center", marginBottom:"12px" }}>
            <div style={{ 
              width:"64px", 
              height:"64px", 
              background:"var(--bg-soft)", 
              borderRadius:"50%", 
              display:"flex", 
              alignItems:"center", 
              justifyContent:"center",
              border:"3px solid var(--bg-section)",
              boxShadow:"0 8px 16px rgba(43, 176, 230, 0.1)"
            }}>
              <SparklesIcon style={{ width:"32px", height:"32px", color:"var(--primary-blue)" }} />
            </div>
          </div>
          <h2
            style={{
              color:"var(--text-heading)",
              fontSize:"24px",
              fontWeight:"900",
              marginBottom:"8px",
              letterSpacing:"-0.02em",
              textTransform:"uppercase"
            }}
          >
            Upgrade to <span style={{ color:"var(--primary-blue)" }}>Premium</span>
          </h2>
          <p style={{ color:"var(--text-body)", fontSize:"16px", fontWeight:"500" }}>
            Unlock the full power of TheSkillGenie
          </p>
        </div>

        {/* Features */}
        <div style={{ marginBottom:"24px" }}>
          <div
            style={{
              background:"#FFFFFF",
              border:"1px solid var(--accent-gray)",
              borderRadius:"20px",
              padding:"16px",
              marginBottom:"12px",
              boxShadow:"inset 0 2px 4px rgba(0,0,0,0.02)"
            }}
          >
            <div style={{ display:"flex", alignItems:"center", gap:"10px", marginBottom:"6px" }}>
              <span style={{ fontSize:"20px" }}>🤖</span>
              <h3 style={{ color:"var(--primary-blue)", fontSize:"18px", fontWeight:"800" }}>
                TSG AI - Exclusive
              </h3>
            </div>
            <p style={{ color:"var(--text-body)", fontSize:"13px", lineHeight:"1.5", fontWeight:"500" }}>
              24/7 AI assistance with instant responses and smart learning guidance. 
            </p>
          </div>

          <div style={{ display:"flex", flexDirection:"column", gap:"8px", marginBottom:"24px", padding:"0 8px" }}>
            {[
              "Unlimited AI Prompts",
              "Full Website Access",
              "Advanced Coding Challenges",
              "Mock Interviews & AI Review",
            ].map((feature, idx) => (
              <div key={idx} style={{ display:"flex", alignItems:"center", gap:"10px" }}>
                <div style={{ 
                  width:"16px", 
                  height:"16px", 
                  backgroundColor:"var(--primary-blue)", 
                  borderRadius:"50%", 
                  display:"flex", 
                  alignItems:"center", 
                  justifyContent:"center",
                  flexShrink: 0
                }}>
                  <span style={{ color:"#fff", fontSize:"10px", fontWeight:"900" }}>✓</span>
                </div>
                <span style={{ color:"var(--text-body)", fontSize:"14px", fontWeight:"600" }}>{feature}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Special Highlight */}
        <div
          style={{
            background:"var(--bg-soft)",
            border:"2px dashed var(--primary-blue)",
            borderRadius:"20px",
            padding:"16px",
            marginBottom:"24px",
            textAlign:"center"
          }}
        >
          <p style={{ color:"var(--primary-blue)", fontSize:"16px", fontStyle:"italic", fontWeight:"900", marginBottom:"2px" }}>
            🎯 Special Offer
          </p>
          <p style={{ color:"var(--text-heading)", fontSize:"14px", fontWeight:"600" }}>
            TSG AI included with{""}
            <span style={{ color:"var(--primary-blue)", fontWeight:"900" }}> 3 & 6-month</span> plans
          </p>
        </div>

        {/* Action Buttons */}
        <div style={{ display:"flex", gap:"12px" }}>
          <button
            onClick={onClose}
            style={{
              flex: 1,
              padding:"12px",
              background:"var(--bg-main)",
              border:"1px solid var(--accent-gray)",
              borderRadius:"14px",
              color:"var(--text-muted)",
              fontSize:"14px",
              fontWeight:"700",
              cursor:"pointer",
              transition:"all 0.3s ease"
            }}
          >
            Later
          </button>
          <button
            onClick={onUpgrade}
            style={{
              flex: 2,
              padding:"14px",
              background:"var(--primary-blue)",
              border:"none",
              borderRadius:"14px",
              color:"#fff",
              fontSize:"16px",
              fontWeight:"900",
              cursor:"pointer",
              display:"flex",
              alignItems:"center",
              justifyContent:"center",
              gap:"8px",
              boxShadow:"0 8px 16px rgba(43, 176, 230, 0.25)",
              transition:"all 0.3s ease",
              textTransform:"uppercase",
            }}
          >
            <span>Upgrade</span>
            <ArrowRightIcon style={{ width:"20px", height:"20px" }} />
          </button>
        </div>
      </div>

      <style>{`
        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(-20px) scale(0.95);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }
      `}</style>
    </div>
  );
};

export default PaymentReminderPopup;




